import Vue from 'vue'
import Router from 'vue-router'
import cms from './app/cms/index'
import iniciar_sesion_cms from './app/cms/vistas/sesion/iniciar_sesion'
import contenido from './app/cms/vistas/contenido/contenido'
import blog from './app/cms/vistas/blog/blog'
import galeria from './app/cms/vistas/galeria/galeria'
import registro_de_correos from './app/cms/vistas/registro_de_correos/registro_de_correos'
import Navegador  from './app/web/navegador'
import Pie_de_pagina  from './app/web/pie_de_pagina'
import goTo from 'vuetify/es5/services/goto'
Vue.use( Router )
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      components:{
        navegador: Navegador,
        default: () => import('./app/web/inicio/index'),
        pie_de_pagina: Pie_de_pagina
      },
      name: 'inicio',
    },
    {
      path: '/nosotros',
      components:{
        navegador: Navegador,
        default: () => import('./app/web/nosotros/index'),
        pie_de_pagina: Pie_de_pagina
      },
      name: 'nosotros',
    },
    {
      path: '/productos/l/:linea_comercial?/c/:categoria?/p/:producto?/b/:busqueda?',
      components:{
        navegador: Navegador,
        default: () => import('./app/web/lineas_comerciales/index'),
        pie_de_pagina: Pie_de_pagina
      },
      name: 'productos',
    },
 
    {
      path: '/proyectos',
      components:{
        navegador: Navegador,
        default:() => import('./app/web/proyectos/index'),
        pie_de_pagina: Pie_de_pagina
      },
      name: 'proyectos',
    },
    {
      path: '/novedades/:articulo?',
      components:{
        navegador: Navegador,
        default: () => import('./app/web/novedades/index'),
        pie_de_pagina: Pie_de_pagina
      },
      name: 'novedades',
    },
    {
      path: '/contacto',
      components:{
        navegador: Navegador,
        default: () => import('./app/web/contacto/index'),
        pie_de_pagina: Pie_de_pagina
      },
      name: 'contacto',
    },
    {
      path: '/cms',
      component: cms,
      children: [
        {
          path: '',
          name: 'iniciar_sesion',
          component: iniciar_sesion_cms,
        },
        {
          path: 'contenido',
          name: 'contenido_cms',
          component: contenido,
        },
        {
          path: 'blog',
          name: 'blog_cms',
          component: blog,
        },
        {
          path: 'galeria',
          name: 'galeria_cms',
          component: galeria,
        },
        {
          path: 'registro_de_correos',
          name: 'registro_de_correos_cms',
          component: registro_de_correos,
        },
      ]
    }
  
  ]
})
router.beforeEach(async (to,from,next)=> {
  try{

    goTo("#navegador")
    if(to.name == "productos")goTo('#contenido-lineas-comerciales')
  }catch (e){
    console.log(e)
  } 

  next()
})
router.scrollBehavior = (to, from, savedPosition) => {
  let scrollTo = 0
  if (to.hash)  scrollTo = to.hash
  else if (savedPosition)  scrollTo = savedPosition.y
  return goTo(scrollTo)
}

export default router